import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
import { withSpacingStyles } from '../withSpacingStyles';

type Props = {
  className?: string,
  children: React.Node,
  tag?: string,
  isColumn?: boolean,
};

export const _Row = forwardRef(({ className, tag, children, isColumn, ...rest }: Props, ref) => (
  <Container className={className} as={tag} ref={ref} isColumn={isColumn} {...rest}>
    {children}
  </Container>
));

export const Row = withSpacingStyles(_Row);

const Container = styled('div')`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: ${({ isColumn }) => isColumn && 'column'};
`;
